import { Navigate } from '@sorare/routing';
import { ANY_SPORT_SERIES_PLAY } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

const SeriesVoucherPage = () => {
  const { generateSportContextPath } = useSportContext();

  return (
    <Navigate
      to={{
        pathname: generateSportContextPath(ANY_SPORT_SERIES_PLAY),
        search: 'welcomePack=true',
      }}
      replace
    />
  );
};

export default SeriesVoucherPage;
